/* eslint-disable max-len */
import _ from 'underscore';
import { constants as C } from '@bingads-webui-campaign-react/image-experience-model';
import {
  // UAPPlacementType as EPlacementType,
  UAPPlacementTypeAlias as PT,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import { CSMLAdTypeAbbr, CSMLAdType } from './constants';

// eslint-disable-next-line prefer-destructuring
const imageAdExtSettings = C.imageAdExtSettings;

export const getPlacementConfig = () => ({
  // MMA
  [PT.MMA.LandscapeImage]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('Landscape image'),
  },
  [PT.MMA.WideImage]: {
    isRequired: false,
    aspectRatioUIString: '4 : 1',
    previewTypeString: _TL_('Wide image'),
  },
  [PT.MMA.SquareImage]: {
    isRequired: true,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('Square image'),
  },
  [PT.MMA.VerticalImage]: {
    isRequired: false,
    aspectRatioUIString: '1 : 2',
    previewTypeString: _TL_('Vertical image'),
  },

  // MMA in MSAN (Audience Network)
  [PT.MSAN.WideImage]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.MSAN.SquareImage]: {
    isRequired: false,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('MSN square image'),
  },
  [PT.MSAN.MSEdgeSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.78 : 1',
    previewTypeString: _TL_('Microsoft Edge single carousel'),
  },
  [PT.MSAN.MSNInArticle]: {
    isRequired: false,
    aspectRatioUIString: '1.5 : 1',
    previewTypeString: _TL_('MSN in-article ad'),
  },
  [PT.MSAN.MSNSmallHeadline]: {
    isRequired: false,
    aspectRatioUIString: '1.33 : 1',
    previewTypeString: _TL_('MSN small headline'),
  },

  // pmax
  [PT.PMax.AudienceSquareImage]: {
    isRequired: false,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('MSN square image'),
  },
  [PT.PMax.AudienceWideImage]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.PMax.MMALandscapeImage]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('Landscape Image Multimedia Ad'),
  },
  [PT.PMax.MMAVerticalImage]: {
    isRequired: false,
    aspectRatioUIString: '1 : 2',
    previewTypeString: _TL_('Vertical image'),
  },
  [PT.PMax.MMAWideImage]: {
    isRequired: false,
    aspectRatioUIString: '4 : 1',
    previewTypeString: _TL_('Wide image'),
  },
  [PT.PMax.MSNInArticle]: {
    isRequired: false,
    aspectRatioUIString: '1.5 : 1',
    previewTypeString: _TL_('MSN in-article ad'),
  },
  [PT.PMax.MSNSmallHeadline]: {
    isRequired: false,
    aspectRatioUIString: '1.33 : 1',
    previewTypeString: _TL_('MSN small headline'),
  },
  [PT.PMax.MSEdgeSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.78 : 1',
    previewTypeString: _TL_('Microsoft Edge single carousel'),
  },
  [PT.PMax.MMAV2MSEdgeCarousel]: {
    isRequired: false,
    aspectRatioUIString: '2.01 : 1',
    previewTypeString: _TL_('Microsoft Edge carousel'),
  },
  [PT.PMax.MMAV2MSNSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.69 : 1',
    previewTypeString: _TL_('MSN carousel'),
  },
  [PT.PMax.MMAV2MSNRestoday]: {
    isRequired: false,
    aspectRatioUIString: '1.24 : 1',
    previewTypeString: _TL_('MSN Restoday'),
  },
  [PT.PMax.MMAV2MSNPartnerStripe]: {
    isRequired: false,
    aspectRatioUIString: '1.53 : 1',
    previewTypeString: _TL_('MSN partner stripe'),
  },
  [PT.PMax.MMAV2MSNRiver]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.PMax.MSEdgeMobile]: {
    isRequired: false,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('Microsoft Edge mobile'),
  },

  // MSAN V2
  [PT.MSANV2.MSEdgeCarousel]: {
    isRequired: false,
    aspectRatioUIString: '2.01 : 1',
    previewTypeString: _TL_('Microsoft Edge carousel'),
  },
  [PT.MSANV2.MSANBanner]: {
    isRequired: false,
    aspectRatioUIString: '2 : 1',
    previewTypeString: _TL_('MSN banner'),
  },
  [PT.MSANV2.MSANRiver]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.MSANV2.MSNCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.69 : 1',
    previewTypeString: _TL_('MSN carousel'),
  },
  [PT.MSANV2.MSNPartnerStripe]: {
    isRequired: false,
    aspectRatioUIString: '1.53 : 1',
    previewTypeString: _TL_('MSN partner stripe'),
  },
  [PT.MSANV2.MSNRestoday]: {
    isRequired: false,
    aspectRatioUIString: '1.24 : 1',
    previewTypeString: _TL_('MSN Restoday'),
  },
  [PT.MSANV2.MSANRectangle]: {
    isRequired: false,
    aspectRatioUIString: '1.2 : 1',
    previewTypeString: _TL_('MSN rectangle image'),
  },
  [PT.MSANV2.MSEdgeMobile]: {
    isRequired: true,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('Microsoft Edge mobile'),
  },

  // Image Extension
  [PT.ImageExt.WideImage]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.ImageExt.MSEdgeSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.78 : 1',
    previewTypeString: _TL_('Microsoft Edge single carousel'),
  },
  [PT.ImageExt.BingDesktopSingleImage]: {
    isRequired: false,
    aspectRatioUIString: '1.78 : 1',
    previewTypeString: _TL_('Bing desktop single-image extension'),
  },
  [PT.ImageExt.MSEdgeMediumHeadline]: {
    isRequired: false,
    aspectRatioUIString: '1.72 : 1',
    previewTypeString: _TL_('Microsoft Edge medium headline'),
  },
  [PT.ImageExt.MSNSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.69 : 1',
    previewTypeString: _TL_('MSN carousel'),
  },
  [PT.ImageExt.MSNMediumHeadline]: {
    isRequired: false,
    aspectRatioUIString: '1.55 : 1',
    previewTypeString: _TL_('MSN medium headline'),
  },
  [PT.ImageExt.MSNInArticle]: {
    isRequired: false,
    aspectRatioUIString: '1.5 : 1',
    previewTypeString: _TL_('MSN in-article ad'),
  },
  [PT.ImageExt.MSNSmallHeadline]: {
    isRequired: false,
    aspectRatioUIString: '1.33 : 1',
    previewTypeString: _TL_('MSN small headline'),
  },
  [PT.ImageExt.BingDesktopMultiImage]: {
    isRequired: false,
    aspectRatioUIString: '1.33 : 1',
    previewTypeString: _TL_('Bing desktop multi-image extension'),
  },
  [PT.ImageExt.BingMobileMultiImage]: {
    isRequired: false,
    aspectRatioUIString: '1.33 : 1',
    previewTypeString: _TL_('Bing mobile multi-image extension'),
  },
  [PT.ImageExt.SquareImage]: {
    isRequired: false,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('MSN square image'),
  },
  [PT.ImageExt.MSNDoubleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '0.93 : 1',
    previewTypeString: _TL_('MSN double carousel'),
  },
  [PT.ImageExt.MMAV2MSNRiver]: {
    isRequired: true,
    aspectRatioUIString: '1.91 : 1',
    previewTypeString: _TL_('MSN feed'),
  },
  [PT.ImageExt.MMAV2MSNSingleCarousel]: {
    isRequired: false,
    aspectRatioUIString: '1.69 : 1',
    previewTypeString: _TL_('MSN carousel'),
  },
  [PT.ImageExt.MSEdgeMobile]: {
    isRequired: false,
    aspectRatioUIString: '1 : 1',
    previewTypeString: _TL_('Microsoft Edge mobile'),
  },
});

export const aspectRatioConfig = isMultimediaAd => ({
  Image191x100: {
    aspectRatio: 1.91,
    aspectRatioAsRatio: '1.91 : 1',
    aspectRatioString: '191X100',
    type: 'Image191x100',
    isRequired: true,
  },
  Image4x1: {
    aspectRatio: 4,
    aspectRatioAsRatio: '4 : 1',
    aspectRatioString: '400X100',
    type: 'Image4x1',
    isRequired: false,
  },
  Image1x1: {
    aspectRatio: 1,
    aspectRatioAsRatio: '1 : 1',
    aspectRatioString: '100X100',
    type: 'Image1x1',
    isRequired: isMultimediaAd,
  },
  Image1x2: {
    aspectRatio: 0.5,
    aspectRatioAsRatio: '1 : 2',
    aspectRatioString: '50X100',
    type: 'Image1x2',
    isRequired: false,
  },
  Image178x100: {
    aspectRatio: 1.78,
    aspectRatioAsRatio: '1.78 : 1',
    aspectRatioString: '178X100',
    type: 'Image178x100',
    isRequired: false,
    extraExtension: {
      BingSingleImage: {
        previewTypeString: imageAdExtSettings.BingSingleImage.previewTypeString,
      },
    },
  },
  Image172x100: {
    aspectRatio: 1.72,
    type: 'Image172x100',
    aspectRatioAsRatio: '1.72 : 1',
    aspectRatioString: '172X100',
    isRequired: false,
  },
  Image169x100: {
    aspectRatio: 1.69,
    type: 'Image169x100',
    aspectRatioAsRatio: '1.69 : 1',
    aspectRatioString: '169X100',
    isRequired: false,
  },
  Image150x100: {
    aspectRatio: 1.5,
    aspectRatioAsRatio: '1.5 : 1',
    aspectRatioString: '150X100',
    type: 'Image150x100',
    isRequired: false,
  },
  Image155x100: {
    aspectRatio: 1.55,
    type: 'Image155x100',
    aspectRatioAsRatio: '1.55 : 1',
    aspectRatioString: '155X100',
    isRequired: false,
  },
  Image133x100: {
    aspectRatio: 1.33,
    aspectRatioAsRatio: '1.33 : 1',
    aspectRatioString: '133X100',
    type: 'Image133x100',
    isRequired: false,
    extraExtension: {
      MobileMultiImage: {
        previewTypeString: imageAdExtSettings.MobileMultiImage.previewTypeString,
      },
      BingDesktopImage: {
        previewTypeString: imageAdExtSettings.BingDesktopImage.previewTypeString,
      },
    },
  },
  Image93x100: {
    aspectRatio: 0.93,
    aspectRatioAsRatio: '0.93 : 1',
    aspectRatioString: '93X100',
    type: 'Image93x100',
    isRequired: false,
  },
  Image201x100: {
    aspectRatio: 2.01,
    aspectRatioAsRatio: '2.01 : 1',
    aspectRatioString: '201X100',
    type: 'Image201x100',
    isRequired: false,
  },
  Image200x100: {
    aspectRatio: 2,
    aspectRatioAsRatio: '2 : 1',
    aspectRatioString: '200X100',
    type: 'Image200x100',
    isRequired: false,
  },
  Image153x100: {
    aspectRatio: 1.53,
    aspectRatioAsRatio: '1.53 : 1',
    aspectRatioString: '153X100',
    type: 'Image153x100',
    isRequired: false,
  },
  Image124x100: {
    aspectRatio: 1.24,
    aspectRatioAsRatio: '1.24 : 1',
    aspectRatioString: '124X100',
    type: 'Image124x100',
    isRequired: false,
  },
  Image120x100: {
    aspectRatio: 1.2,
    aspectRatioAsRatio: '1.2 : 1',
    aspectRatioString: '120X100',
    type: 'Image120x100',
    isRequired: false,
  },
});

export const getAspectRatioConfig = (adType, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled) => {
  const aspectRatios = C.getAspectRatios({
    isMultimediaAd: adType === CSMLAdType.MMA,
    isMultimediaAdinMSANEnabled: CSMLAdType.Audience === adType,
    isCombinedMsanAndMmaAspectRatios: CSMLAdType.PMax === adType,
    isMMAV2Enabled: CSMLAdType.Audience === adType && isMMAV2Enabled,
    isPMaxAspectRatiosV2Enabled: CSMLAdType.PMax === adType && isPMaxAspectRatiosV2Enabled,
  });

  const allAspectRatioConfig = aspectRatioConfig(adType === CSMLAdType.MMA);

  const aspectRatiosExceptOriginal = _.omit(aspectRatios, 'OriginalImage');

  const subAspectRatioConfig = _.mapObject(aspectRatiosExceptOriginal, item => ({
    ...allAspectRatioConfig[item.type],
    minSize: item.minSize,
    previewTypeString: item.previewTypeString,
    placementType: `${CSMLAdTypeAbbr[adType]}${allAspectRatioConfig[item.type].aspectRatioString}`,
  }));

  return subAspectRatioConfig;
};

export const getPreviewText = (isImageExtension, i18n) => {
  if (isImageExtension) {
    return {
      shortHeadline: i18n.getString(_TL_('Title part 1')),
      longHeadline: i18n.getString(_TL_('Title part 1 | Title part 2 | Title part 3')),
      description: i18n.getString(_TL_('Ad text 1. Ad text 2')),
      businessName: i18n.getString(_TL_('Business name')),
      url: 'https://example.com',
      finalUrl: 'https://example.com',
    };
  }

  return {
    shortHeadline: i18n.getString(_TL_('Short headline')),
    longHeadline: i18n.getString(_TL_('Long headline')),
    description: i18n.getString(_TL_('Ad text')),
    businessName: i18n.getString(_TL_('Business name')),
    url: 'https://example.com',
    finalUrl: 'https://example.com',
    callToAction: i18n.getString(_TL_('Shop Now')),
  };
};

export const sizeValidForRatio = (minSize, cropSettings) => {
  if (cropSettings && minSize) {
    const { SourceWidth, SourceHeight } = cropSettings;
    if (SourceWidth < minSize[0] || SourceHeight < minSize[1]) {
      return false;
    }
  }

  return true;
};

export const getSizeErrorRatioList = (
  adType,
  cropSettings,
  requiredOnly = false,
  isMMAV2Enabled = false,
  isPMaxAspectRatiosV2Enabled = false
) => {
  let ratioList = getAspectRatioConfig(adType, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled);

  if (requiredOnly) {
    ratioList = _.filter(ratioList, config => config.isRequired);
  }

  const invalidRatioList = _.filter(ratioList, (item) => {
    const { minSize } = item;
    return !sizeValidForRatio(minSize, cropSettings);
  });

  return invalidRatioList;
};

export const getAllSizeErrorRatioList = (cropSettings, requiredOnly = false, isMMAV2Enabled = false, isPMaxAspectRatiosV2Enabled = false) => {
  const errorListForMMA = getSizeErrorRatioList(CSMLAdType.MMA, cropSettings, requiredOnly, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled);
  const errorListForAudience = getSizeErrorRatioList(CSMLAdType.Audience, cropSettings, requiredOnly, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled);
  const errorListForExtension = getSizeErrorRatioList(CSMLAdType.ImageExtension, cropSettings, requiredOnly, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled);
  const errorListForPmax = getSizeErrorRatioList(CSMLAdType.Pmax, cropSettings, requiredOnly, isMMAV2Enabled, isPMaxAspectRatiosV2Enabled);

  return _.uniq(
    [...errorListForAudience, ...errorListForExtension, ...errorListForMMA, ...errorListForPmax],
    item => item.type
  );
};

export const getPlacementsToExpand = (adType) => {
  const aspectRatios = C.getAspectRatios({
    isMultimediaAd: adType === CSMLAdType.MMA,
    isMultimediaAdinMSANEnabled: CSMLAdType.Audience === adType,
    isMMAV2Enabled: adType === CSMLAdType.Audience,
    isCombinedMsanAndMmaAspectRatios: adType === CSMLAdType.PMax,
  });

  const placementsToExpand = _.chain(aspectRatios)
    .reject(p => CSMLAdType.Audience === adType && p.type === 'OriginalImage')
    .map(({ aspectRatio, minSize }) => ({ aspectRatio, minHeight: minSize[1] }))
    .value();

  return placementsToExpand;
};
